import $http from '@/http'

const state = {
  user: null,
};

const getters = {
  isAuthenticated: state => !!state.user,
  stateUser: state => state.user,
};

const actions = {
  async logIn({dispatch}, user) {
    await $http.post('login', user);
    await dispatch('viewMe');
  },
  async viewMe({commit}) {
    let {data} = await $http.get('users/whoami');
    await commit('setUser', data);
  },
  async logOut({commit}) {
    let user = null;
    commit('logout', user);
  }
};

const mutations = {
  setUser(state, username) {
    state.user = username;
  },
  logout(state, user){
    state.user = user;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
